import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import Dexie from 'dexie';
import { BehaviorSubject } from 'rxjs';
import { Fetch } from './fetch';

@Injectable({
  providedIn: 'root'
})
export class FetchCacheService {
  private db: any;
  private currentlyLoading: any = {};
  private _droppedDb = new BehaviorSubject<null>(null);
  private readonly isServer = isPlatformServer(inject(PLATFORM_ID));

  get droppedDatabase$() {
    return this._droppedDb.asObservable();
  }

  constructor() {
    if (this.isServer) {
      return;
    }

    this.db = new Dexie('fetch-cache');
    this.db.version(1).stores({
      data: '[metrics+dimensions+filterHash+startDate+endDate+previousStartDate+previousEndDate]'
    });

    this.db.open().catch(error => {
      console.warn('[FetchCache] Error during connecting to database:', error);
    });
  }

  addData(fetch: Fetch, data: any) {
    if (this.isServer) {
      return Promise.resolve(null);
    }
    return this.db.data.add({
      dimensions: fetch.dimensions,
      metrics: fetch.metrics,
      filterHash: JSON.stringify(fetch.filters),
      filters: fetch.filters,
      startDate: fetch.startDatetime.format('YYYY-MM-DD'),
      endDate: fetch.endDatetime.format('YYYY-MM-DD'),
      previousStartDate: fetch.previousPeriod ? fetch.previousPeriod.startDatetime.format('YYYY-MM-DD') : '',
      previousEndDate: fetch.previousPeriod ? fetch.previousPeriod.endDatetime.format('YYYY-MM-DD') : '',
      data
    });
  }

  findCache(fetch: Fetch) {
    if (this.isServer) {
      return Promise.resolve(null);
    }
    try {
      return this.db.data.get({
        dimensions: fetch.dimensions,
        metrics: fetch.metrics,
        filterHash: JSON.stringify(fetch.filters),
        startDate: fetch.startDatetime.format('YYYY-MM-DD'),
        endDate: fetch.endDatetime.format('YYYY-MM-DD'),
        previousStartDate: fetch.previousPeriod?.startDatetime?.format('YYYY-MM-DD') || '',
        previousEndDate: fetch.previousPeriod?.endDatetime?.format('YYYY-MM-DD') || ''
      });
    } catch (e) {
      console.warn(e);
      return null;
    }
  }

  getLoading(fetch: Fetch) {
    return this.currentlyLoading[JSON.stringify(fetch)];
  }

  addLoading(fetch: Fetch, promise: Promise<any>) {
    this.currentlyLoading[JSON.stringify(fetch)] = promise;
  }

  removeLoading(fetch: Fetch) {
    this.currentlyLoading[JSON.stringify(fetch)] = undefined;
  }

  async dropDatabase() {
    if (!this.isServer) {
      await this.db.data.clear();
    }
    this._droppedDb.next(null);
  }
}
